import { setTabs, setActiveTab } from "../slices/workspace";

export const openTab = (tabData) => (dispatch, getState) => {
  const { tabs } = getState().workspace;
  const existingTab = tabs.find((tab) => tab.id === tabData.id);

  if (!existingTab) {
    const newTabs = [...tabs, tabData];
    dispatch(setTabs(newTabs));
  }
  dispatch(setActiveTab(tabData.id));
};

export const closeTab = (tabId) => (dispatch, getState) => {
  const { tabs, activeTabId } = getState().workspace;
  const index = tabs.findIndex((tab) => tab.id === tabId);

  if (index !== -1) {
    const newTabs = [...tabs];
    newTabs.splice(index, 1);

    if (activeTabId === tabId) {
      const nextTab = newTabs[index] || newTabs[index - 1];
      dispatch(setActiveTab(nextTab ? nextTab.id : null));
    }
    dispatch(setTabs(newTabs));
  }
};

export const focusTab = (tabId) => (dispatch, getState) => {
  const { activeTabId } = getState().workspace;
  if (activeTabId !== tabId) {
    dispatch(setActiveTab(tabId));
  }
};
